import { render, staticRenderFns } from "./kurssikoodi.vue?vue&type=template&id=4daaf052&scoped=true&"
import script from "./kurssikoodi.vue?vue&type=script&lang=ts&"
export * from "./kurssikoodi.vue?vue&type=script&lang=ts&"
import style0 from "./kurssikoodi.vue?vue&type=style&index=0&id=4daaf052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daaf052",
  null
  
)

export default component.exports